import { render } from "./index.vue?vue&type=template&id=a9551456&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a9551456&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9551456"],['__file',"src/components/BaseUi/Search/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9551456"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9551456', __exports__)) {
    api.reload('a9551456', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a9551456&scoped=true", () => {
    api.rerender('a9551456', render)
  })

}


export default __exports__